import isHotKey from 'is-hotkey';
import BlockTypes from '../../../types/BlockTypes';
import isFirstLine from '../utils/isFirstLine';
import isFirstCharacter from '../utils/isFirstCharacter';
var isArrowUp = isHotKey('up');
var isBackspace = isHotKey('backspace');
export default function makeOnKeyDown(options) {
  var focusPrevious = options.focusPrevious;
  return function onKeyDown(event, editor, next) {
    if (editor.value.selection.isUnset) return next();

    if (isBackspace(event) && isFirstCharacter(editor) && (!editor.query('isIndented') || !editor.query('canChangeDepth'))) {
      event.preventDefault();
      var startBlock = editor.value.startBlock;

      if (startBlock.type !== BlockTypes.UNSTYLED) {
        return editor.hasCommand('resetBlocks') ? editor.command('resetBlocks') : editor.setBlocks(BlockTypes.UNSTYLED);
      }

      if (startBlock.text === '') {
        editor.removeNodeByKey(startBlock.key);
      }

      editor.blur();
      focusPrevious({
        at: -1
      });
      return editor;
    }

    if (isArrowUp(event) && !event.shiftKey && isFirstLine(editor)) {
      event.preventDefault();
      return focusPrevious({
        at: editor.value.selection.start.offset
      });
    }

    return next();
  };
}